'use client';

import { formatDateRange } from '@fshr/shared';
import type { TypeAheadFilterResult } from '../type-ahead';
import type { PPUpcomingBooking } from '@micro-apps/env';

type BookingOptionDisplayProps = {
	booking: PPUpcomingBooking;
	result: TypeAheadFilterResult;
};

export function BookingOptionDisplay({ booking, result }: BookingOptionDisplayProps) {
	const highlightedConfirmation = result.string ?? result.original;
	const propertyName = booking.propertyShortName || booking.propertyOrsCode;
	const dateRange = formatDateRange(booking.checkInDate, booking.checkOutDate, true);

	return (
		<div className="flex w-full flex-col gap-[2px] text-start [&_mark]:bg-transparent [&_mark]:font-bold [&_mark]:text-inherit">
			<span
				className="text-body2 text-text-primary"
				dangerouslySetInnerHTML={{ __html: highlightedConfirmation }}
			/>
			<span className="text-caption text-text-secondary">
				{propertyName} | {booking.lastName} | {dateRange}
			</span>
		</div>
	);
}
